<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class PaymentOptionImg extends Vue {
        render() {
            return null
        }
    }

    export default PaymentOptionImg
</script>
